import { useGet } from '../../../../api';

export type DefaultStaleAccessSettingDto = {
    response: number;
};

export const useGetDefaultStaleAccessSetting = () => {
    const { data, error, fetchData, loading } = useGet<DefaultStaleAccessSettingDto>({
        url: `/accessAnalysis/defaultStaleAccessSettings/`
    });

    return { defaultStaleAccessSetting: data?.response, refetch: fetchData, isLoading: loading, error };
};
